import  api  from './api';

export const getSinisterStatus = async (codeType) => {
    let synisterStatus = null;
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        },
        params: { codeType }
    }
    try {
        const response = await api.get(`Settings/genericlist/list`, config);
        synisterStatus = response.data.data;
    } catch (err) {}
    return synisterStatus;
}

export const getSinisterPort = async (codeType) => {
    let synisterPorts = null;
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        },
        params: { codeType }
    }
    try {
        const response = await api.get(`Settings/genericlist/list`, config);
        synisterPorts = response.data.data;
    } catch (err) {}
    return synisterPorts;
}

export const getSinisterTypes = async (status = null) => {
    let synisterTypes = null;
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        },
        params: { status: status }
    }
    try {
        const response = await api.get(`Sinistro/tiposinistro`, config);
        synisterTypes = response.data.data;
    } catch (err) {}
    return synisterTypes;
}

export const getDepartamentTypes = async (status = null) => {
    let synisterTypes = null;
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        },
        params: { status: status }
    }
    try {
        const response = await api.get(`Sinistro/departamentos`, config);
        synisterTypes = response.data.data;
    } catch (err) {}
    return synisterTypes;
}